import { render, staticRenderFns } from "./yjdc.vue?vue&type=template&id=b9680074&scoped=true&"
import script from "./yjdc.vue?vue&type=script&lang=js&"
export * from "./yjdc.vue?vue&type=script&lang=js&"
import style0 from "./yjdc.vue?vue&type=style&index=0&id=b9680074&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9680074",
  null
  
)

export default component.exports